export const navCards = [
  { href: "/actress", img: "https://zetsubou.jp/wp-content/uploads/actress-eye-500x281.webp", alt: "AV女優", label: "AV女優" },
  { href: "/newface", img: "https://zetsubou.jp/wp-content/uploads/newface-eye-500x281.webp", alt: "新人女優", label: "新人女優" },
  { href: "/ranking", img: "https://zetsubou.jp/wp-content/uploads/ranking-eye-1-500x281.webp", alt: "ランキング", label: "ランキング" },
];

export const popularArticles = [
  {
    rank: 1,
    href: "https://av.zetsubou.org/newface/list-2025/",
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/55979-featured-320x180.webp",
    title: "【完全網羅】2025-2026年デビュー・デビュー予定の新人AV女優リスト|月別・メーカー別に全員掲載",
    views: "808,444 views",
  },
  {
    rank: 2,
    href: "https://av.zetsubou.org/actress-ranking/",
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/50188-featured-320x180.webp",
    title: "【可愛さの暴力】可愛いAV女優ランキング2026!顔面最強・美人・神スタイル30選",
    views: "751,581 views",
  },
  {
    rank: 3,
    href: "https://av.zetsubou.org/short-hair/",
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/43040-featured-320x180.webp",
    title: "【俺たちの憧れ】かわいいショートカットAV女優を30人紹介させてくれ-2026年の1位はこの子だ!",
    views: "375,002 views",
  },
  {
    rank: 4,
    href: "https://av.zetsubou.org/av-2025/",
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/50144-featured-320x180.webp",
    title: "【超完全まとめ】2024~2026年のおすすめ人気AV女優&全ジャンル作品完全リスト!これ一つで全てがわかる!",
    views: "234,074 views",
  },
  {
    rank: 5,
    href: "https://av.zetsubou.org/kyonyu/",
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/67111-featured-320x180.webp",
    title: "【おっぱい戦闘力】巨乳・爆乳AV女優ランキング40選!美人・新人・殿堂入りまで徹底解説",
    views: "223,800 views",
  },
  {
    rank: 6,
    href: "https://av.zetsubou.org/rape/",
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/19944-featured-320x180.webp",
    title: "【絶望しか感じない】伝説の鬼畜レイプAVを紹介させてくれ【極悪リスト】|おすすめ神作&人気シリーズまとめ",
    views: "219,125 views",
  },
  {
    rank: 7,
    href: "https://av.zetsubou.org/vrav/masterpiece/",
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/55764-featured-320x180.webp",
    title: "これが最高のVRAVだ!2026年【アダルトVR殿堂入り】オススメVRエロ動画",
    views: "205,881 views",
  },
];

export const actressRankings = [
  {
    rank: 1,
    href: "https://zlovers.jp/suzumori-remu/",
    img: "https://zlovers.jp/wp-content/uploads/suzumori-remu-eye-1-640x360.jpg",
    title: "【美女神】SSS級女優・涼森れむ-おすすめAV&VRリストとレビューまとめ",
    views: "9816 views",
  },
  {
    rank: 2,
    href: "https://zlovers.jp/ishikawa-mio/",
    img: "https://zlovers.jp/wp-content/uploads/ishikwa-mio-eye-640x360.jpg",
    title: "【最上位天使】AV女優『石川澪』-おすすめAV&VRリストとレビューまとめ",
    views: "5747 views",
  },
  {
    rank: 3,
    href: "https://zlovers.jp/yatsugake-umi/",
    img: "https://zlovers.jp/wp-content/uploads/cap_e_5_abw-293-eye-640x360.jpg",
    title: "【極上AV女優名鑑】八掛うみのおすすめ作品紹介&レビュー【SSランク】",
    views: "4648 views",
  },
  {
    rank: 4,
    href: "https://zlovers.jp/kawakita-saika/",
    img: "https://zlovers.jp/wp-content/uploads/kawakita-saika-eye-320x180.jpg",
    title: "【神話級の美女】AV女優・河北彩花-おすすめAV&VRリストとレビューまとめ",
    views: "4183 views",
  },
  {
    rank: 5,
    href: "https://zlovers.jp/matsumoto-ichika/",
    img: "https://zlovers.jp/wp-content/uploads/matsumoto-ichika-640x360.webp",
    title: "松本いちか完全ガイド|伝説級女優のおすすめAVまとめ",
    views: "3403 views",
  },
];

export const makerRankings = [
  {
    rank: 1,
    href: "https://zlove.jp/attackers/",
    img: "https://zlove.jp/wp-content/uploads/same00011jp-eye-640x360.jpg",
    title: "【美しきレイプ】胸糞系AV最強メーカー『アタッカーズ』の魅力とおすすめ作品",
    views: "8068 views",
  },
  {
    rank: 2,
    href: "https://zlove.jp/poison/",
    img: "https://zlove.jp/wp-content/uploads/enki00054jp-18-640x360.jpg",
    title: "【鬼畜輪姦AV】毒宴会|凄惨イラマと美人女優の背徳映像",
    views: "5281 views",
  },
  {
    rank: 3,
    href: "https://zlove.jp/s-1/",
    img: "https://zlove.jp/wp-content/uploads/s-1-eye-1-640x360.jpg",
    title: "【AV界の絶対王者】S1(エスワン)完全ガイド|絶対に見るべき女優&神作厳選紹介",
    views: "3685 views",
  },
  {
    rank: 4,
    href: "https://zlove.jp/toyohiko/",
    img: "https://zlove.jp/wp-content/uploads/zkwd00020jp-20-eye-640x360.jpg",
    title: "【鬼畜凌辱】AVメーカー『豊彦』の唯一無二のダークな色気と映像美",
    views: "3451 views",
  },
  {
    rank: 5,
    href: "https://zlove.jp/madonna/",
    img: "https://zlove.jp/wp-content/uploads/madonna-eye-1-640x360.webp",
    title: "【熟女・人妻の最高峰】『マドンナ』の専属AV女優とおすすめAVはこれだ!",
    views: "3136 views",
  },
  {
    rank: 6,
    href: "https://zlove.jp/prestige/",
    img: "https://zlove.jp/wp-content/uploads/cap_e_2_abw-326-640x360.webp",
    title: "【伝説的美女軍団】プレステージ徹底攻略|人気AV女優・おすすめ作品を総まとめ!",
    views: "2984 views",
  },
];

export const latestArticles = [
  {
    href: "https://zetsubou.jp/av/newface/selection-2026-02/",
    img: "https://zetsubou.jp/wp-content/uploads/cawd00953jp-10-500x281.webp",
    title: "【2026年2月】新人AV女優おすすめランキング!厳選レビュー&点数付き",
    date: "2026.03.10",
  },
  {
    href: "https://zetsubou.jp/av/vrav/category/",
    img: "https://zetsubou.jp/wp-content/uploads/mig-3-320x180.webp",
    title: "アダルトVR(エロVR)全記事一覧【2026年最新版】",
    date: "2026.02.15",
  },
  {
    href: "https://zetsubou.jp/av/newface/selection-2026/",
    img: "https://zetsubou.jp/wp-content/uploads/snos00081jp-8-500x281.webp",
    title: "【全員評価&徹底レビュー】2026年デビューの新人AV女優|厳選おすすめ&月別ランキング",
    date: "2026.02.14",
  },
  {
    href: "https://zetsubou.jp/av/newface/selection-2026-01/",
    img: "https://zetsubou.jp/wp-content/uploads/1sdnm00538vjp-3-500x281.webp",
    title: "【2026年1月】新人AV女優おすすめランキング!厳選レビュー&点数付き",
    date: "2026.02.14",
  },
  {
    href: "https://zetsubou.jp/av/newface/category/",
    img: "https://zetsubou.jp/wp-content/uploads/mig-3-320x180.webp",
    title: "新人AV女優全記事一覧【2021-2026全記録】",
    date: "2026.02.14",
  },
  {
    href: "https://zetsubou.jp/av/newface/selection-2025-12/",
    img: "https://zetsubou.jp/wp-content/uploads/ipzz00770jp-5-500x281.webp",
    title: "【2025年12月の新人AV女優】点数付きレビュー&おすすめランキング",
    date: "2026.01.15",
  },
];

export const saleItems = [
  {
    label: "【春のパンツまつり30%OFF】",
    href: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fvideo.dmm.co.jp%2Fav%2Flist%2F%3Fcampaign%3Dharunopantsumatsuri&af_id=z1-001&ch=toolbar&ch_id=link",
    img: "https://av.zetsubou.org/wp-content/uploads/f9466040-d05f-4ff2-97c2-f4777c409c16.jpg",
    recommend: "新ありなの引退作品(2D)と未歩ななの引退VR",
    hint: "石川と金松",
    priority: "B",
  },
  {
    label: "【KMPグループ30%OFF】",
    href: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fvideo.dmm.co.jp%2Fav%2Flist%2F%3Fcampaign%3DiT8xZgePRNmdGd10ipsQPg&af_id=z1-001&ch=toolbar&ch_id=link",
    img: "https://av.zetsubou.org/wp-content/uploads/6bfdfacd-9bec-497b-bff0-6b68da16c04c.jpg",
    recommend: "新村あかりのVR",
    hint: "",
    priority: "B",
  },
  {
    label: "【みんなのお気に入り30%OFF】",
    href: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fvideo.dmm.co.jp%2Fav%2Flist%2F%3Fcampaign%3Duresujivideo%26media_type%3Dvr%26sort%3Dsuggest&af_id=z1-001&ch=toolbar&ch_id=link",
    img: "https://av.zetsubou.org/wp-content/uploads/16fe363d-738a-41a0-848b-e33d14117005.jpg",
    recommend: "尾崎えりかの舐め特化と聖レズ",
    hint: "",
    priority: "C",
  },
];

export const actressItems = [
  {
    id: "1",
    name: "涼森れむ",
    img: "https://zlovers.jp/wp-content/uploads/suzumori-remu-eye-1-640x360.jpg",
    href: "https://zlovers.jp/suzumori-remu/",
    description: "SSS級の美貌を誇るトップ女優。抜群のスタイルと演技力で圧倒的な人気を誇る。",
    actressGuideSlug: "suzumori-remu",
  },
  {
    id: "2",
    name: "石川澪",
    img: "https://zlovers.jp/wp-content/uploads/ishikwa-mio-eye-640x360.jpg",
    href: "https://zlovers.jp/ishikawa-mio/",
    description: "最上位天使の異名を持つ美人女優。清楚な外見と激しい演技の落差が魅力。",
    actressGuideSlug: "ishikawa-mio",
  },
  {
    id: "3",
    name: "八掛うみ",
    img: "https://zlovers.jp/wp-content/uploads/cap_e_5_abw-293-eye-640x360.jpg",
    href: "https://zlovers.jp/yatsugake-umi/",
    description: "極上の美貌と色気が両立。SSランクの実力派女優として高い評価を得ている。",
  },
  {
    id: "4",
    name: "河北彩花",
    img: "https://zlovers.jp/wp-content/uploads/kawakita-saika-eye-320x180.jpg",
    href: "https://zlovers.jp/kawakita-saika/",
    description: "神話級の美女と称される圧倒的な美貌の持ち主。ファン絶賛の演技派。",
  },
  {
    id: "5",
    name: "松本いちか",
    img: "https://zlovers.jp/wp-content/uploads/matsumoto-ichika-640x360.webp",
    href: "https://zlovers.jp/matsumoto-ichika/",
    description: "伝説級の存在感。可愛さと色気を兼ね備えたオールラウンダー女優。",
  },
];

export const actressGuidePages = [
  {
    id: "ag-1",
    slug: "suzumori-remu",
    name: "涼森れむ",
    profileImg: "https://zlovers.jp/wp-content/uploads/suzumori-remu-eye-1-640x360.jpg",
    heroImg: "https://zlovers.jp/wp-content/uploads/suzumori-remu-eye-1-640x360.jpg",
    rank: "SSS",
    debutDate: "2022年4月",
    maker: "S1 NO.1 STYLE",
    height: "158cm",
    bust: "F",
    waist: "57cm",
    hip: "85cm",
    bio: "2022年4月にS1 NO.1 STYLEからデビューした超絶美女。デビュー直後からその圧倒的な美貌と演技力で業界を席巻し、わずか1年でトップ女優の座に君臨。清楚な外見とは裏腹に激しいシーンも全力でこなす姿勢がファンを魅了し続けている。スタイル・顔・演技力の三拍子が揃った現役最強クラスの女優。",
    totalScore: 10,
    affiliateBannerHref: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2F&af_id=z1-001&ch=toolbar&ch_id=link",
    affiliateBannerImg: "",
    affiliateBannerText: "涼森れむの全作品をFANZAで見る",
    works: [
      {
        id: "w1",
        title: "【デビュー作】涼森れむ SOLOデビュー 清楚系美女の衝撃初体験",
        img: "https://public.readdy.ai/ai/img_res/e3d443412d116253fcb561fca4e9d8f8.jpg",
        affiliateHref: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2F&af_id=z1-001&ch=toolbar&ch_id=link",
        score: 10,
        review: "デビュー作とは思えない完成度の高さ。緊張感の中にも堂々とした演技が光り、S1の丁寧な撮影と相まって最高の仕上がりになっている。顔面偏差値が高すぎて見ているだけで幸せになれる一作。",
        releaseDate: "2022年4月",
        maker: "S1 NO.1 STYLE",
        genre: "単体作品",
      },
      {
        id: "w2",
        title: "涼森れむ 専属第2弾 美しき肢体の全て",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20DVD%20cover%20beautiful%20actress%20second%20work%20professional%20photography%20studio%20lighting%20elegant%20pose%20clean%20background%20product%20shot&width=320&height=180&seq=ag1w2&orientation=landscape",
        affiliateHref: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2F&af_id=z1-001&ch=toolbar&ch_id=link",
        score: 9,
        review: "2作目にして既に貫禄すら感じる。デビュー作より更に大胆になった演技と、磨きがかかった美貌のコンビネーションが最高。S1の映像クオリティも相変わらず高く、全シーン見応えがある。",
        releaseDate: "2022年7月",
        maker: "S1 NO.1 STYLE",
        genre: "単体作品",
      },
      {
        id: "w3",
        title: "涼森れむ VR作品 超高画質で体験する至高の時間",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20VR%20DVD%20cover%20beautiful%20actress%20virtual%20reality%20work%20professional%20photography%20studio%20lighting%20clean%20background%20product%20shot&width=320&height=180&seq=ag1w3&orientation=landscape",
        affiliateHref: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2F&af_id=z1-001&ch=toolbar&ch_id=link",
        score: 10,
        review: "VR作品の中でも群を抜いたクオリティ。れむちゃんの美貌がVRで更に際立ち、没入感が半端ない。VR持ってる人は絶対に見るべき一作。これのためにVR買っても後悔しないレベル。",
        releaseDate: "2023年1月",
        maker: "S1 NO.1 STYLE",
        genre: "VR",
      },
    ],
  },
  {
    id: "ag-2",
    slug: "ishikawa-mio",
    name: "石川澪",
    profileImg: "https://zlovers.jp/wp-content/uploads/ishikwa-mio-eye-640x360.jpg",
    heroImg: "https://zlovers.jp/wp-content/uploads/ishikwa-mio-eye-640x360.jpg",
    rank: "SS",
    debutDate: "2023年6月",
    maker: "IDEAPOCKET",
    height: "155cm",
    bust: "E",
    waist: "55cm",
    hip: "83cm",
    bio: "2023年6月にIDEAPOCKETからデビューした最上位天使。清楚で透明感のある外見が特徴で、デビュー直後から多くのファンを獲得。IDEAPOCKETの高品質な映像と彼女の美貌が完璧にマッチしており、毎作品が高評価を獲得している。",
    totalScore: 9,
    affiliateBannerHref: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2F&af_id=z1-001&ch=toolbar&ch_id=link",
    affiliateBannerImg: "",
    affiliateBannerText: "石川澪の全作品をFANZAで見る",
    works: [
      {
        id: "w1",
        title: "石川澪 デビュー作 清楚系天使の衝撃初登場",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20DVD%20cover%20elegant%20beautiful%20actress%20debut%20work%20IDEAPOCKET%20professional%20photography%20studio%20lighting%20clean%20white%20background%20product%20shot&width=320&height=180&seq=ag2w1&orientation=landscape",
        affiliateHref: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2F&af_id=z1-001&ch=toolbar&ch_id=link",
        score: 9,
        review: "IDEAPOCKETらしい高品質な映像と石川澪の清楚な美貌が完璧にマッチ。デビュー作とは思えない落ち着いた演技と、それでいて全力な姿勢が印象的。今後の活躍が非常に楽しみな一作。",
        releaseDate: "2023年6月",
        maker: "IDEAPOCKET",
        genre: "単体作品",
      },
      {
        id: "w2",
        title: "石川澪 第2弾 天使の素顔",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20DVD%20cover%20beautiful%20actress%20second%20work%20IDEAPOCKET%20professional%20photography%20studio%20lighting%20elegant%20pose%20clean%20background%20product%20shot&width=320&height=180&seq=ag2w2&orientation=landscape",
        affiliateHref: "https://al.fanza.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2F&af_id=z1-001&ch=toolbar&ch_id=link",
        score: 9,
        review: "2作目でさらに磨きがかかった。デビュー作より大胆になりつつも清楚感は健在。IDEAPOCKETの映像美と彼女の美貌の相乗効果が最高。",
        releaseDate: "2023年10月",
        maker: "IDEAPOCKET",
        genre: "単体作品",
      },
    ],
  },
];

export const newFaceItems = [
  {
    id: "1",
    name: "2026年2月 デビュー厳選",
    img: "https://zetsubou.jp/wp-content/uploads/cawd00953jp-10-500x281.webp",
    href: "https://zetsubou.jp/av/newface/selection-2026-02/",
    slug: "selection-2026-02",
    debutDate: "2026年2月",
    maker: "E-BODY",
  },
  {
    id: "2",
    name: "2026年1月 デビュー厳選",
    img: "https://zetsubou.jp/wp-content/uploads/1sdnm00538vjp-3-500x281.webp",
    href: "https://zetsubou.jp/av/newface/selection-2026-01/",
    slug: "selection-2026-01",
    debutDate: "2026年1月",
    maker: "SOD Create",
  },
  {
    id: "3",
    name: "2025年12月 デビュー厳選",
    img: "https://zetsubou.jp/wp-content/uploads/ipzz00770jp-5-500x281.webp",
    href: "https://zetsubou.jp/av/newface/selection-2025-12/",
    debutDate: "2025年12月",
    maker: "IDEAPOCKET",
  },
  {
    id: "4",
    name: "2026年全デビュー女優リスト",
    img: "https://zetsubou.jp/wp-content/uploads/snos00081jp-8-500x281.webp",
    href: "https://zetsubou.jp/av/newface/selection-2026/",
    debutDate: "2026年",
    maker: "各社",
  },
  {
    id: "5",
    name: "涼森れむ",
    img: "https://zlovers.jp/wp-content/uploads/suzumori-remu-eye-1-640x360.jpg",
    href: "https://zlovers.jp/suzumori-remu/",
    actressSlug: "suzumori-remu",
    debutDate: "2022年",
    maker: "S1 NO.1 STYLE",
  },
  {
    id: "6",
    name: "石川澪",
    img: "https://zlovers.jp/wp-content/uploads/ishikwa-mio-eye-640x360.jpg",
    href: "https://zlovers.jp/ishikawa-mio/",
    actressSlug: "ishikawa-mio",
    debutDate: "2023年",
    maker: "IDEAPOCKET",
  },
];

export const newFaceDetailPages = [
  {
    id: "nf-1",
    slug: "selection-2026-02",
    title: "【2026年2月】新人AV女優おすすめランキング！厳選レビュー＆点数付き",
    subtitle: "2026年2月デビューの新人を全員チェックして厳選しました",
    date: "2026.03.10",
    intro: "2026年2月にデビューした新人AV女優の中から、特に注目の女優をピックアップしてレビューします。スタイル・顔・演技力など総合的に評価して点数付きで紹介。気になる子はぜひチェックしてみてください！",
    heroImg: "https://zetsubou.jp/wp-content/uploads/cawd00953jp-10-500x281.webp",
    actresses: [
      {
        id: "a1",
        rank: 1,
        name: "桜木ここな",
        mainImg: "https://zetsubou.jp/wp-content/uploads/cawd00953jp-10-500x281.webp",
        score: 9,
        review: "2月のNo.1は断然この子。顔面偏差値がとにかく高く、清楚系の見た目なのに激しい演技も全力でこなす。デビュー作からクオリティが高すぎて将来のトップ女優候補筆頭。スタイルも抜群で文句のつけようがない。",
        href: "https://zetsubou.jp/av/newface/selection-2026-02/",
        workImages: [
          "https://zetsubou.jp/wp-content/uploads/cawd00953jp-10-500x281.webp",
        ],
        debutDate: "2026年2月",
        maker: "E-BODY",
      },
      {
        id: "a2",
        rank: 2,
        name: "月城あんな",
        mainImg: "https://zetsubou.jp/wp-content/uploads/1sdnm00538vjp-3-500x281.webp",
        score: 8,
        review: "ちょっとポヤっとした雰囲気が最高にかわいい。SODらしいまじめな演出と相性抜群で、一発目から完成度の高い作品になっていた。表情の豊かさが特に印象的。今後の作品に期待大。",
        href: "https://zetsubou.jp/av/newface/selection-2026-01/",
        workImages: [
          "https://zetsubou.jp/wp-content/uploads/1sdnm00538vjp-3-500x281.webp",
        ],
        debutDate: "2026年2月",
        maker: "SOD Create",
      },
      {
        id: "a3",
        rank: 3,
        name: "雨宮もえ",
        mainImg: "https://zetsubou.jp/wp-content/uploads/ipzz00770jp-5-500x281.webp",
        score: 7,
        review: "IDEAPOCKETのデビュー作らしく映像クオリティが非常に高い。スタイル抜群のスレンダーボディが映えまくっている。少し緊張気味だったのが惜しいが、ポテンシャルは感じた。",
        href: "https://zetsubou.jp/av/newface/selection-2025-12/",
        workImages: [
          "https://zetsubou.jp/wp-content/uploads/ipzz00770jp-5-500x281.webp",
        ],
        debutDate: "2026年2月",
        maker: "IDEAPOCKET",
      },
    ],
  },
  {
    id: "nf-2",
    slug: "selection-2026-01",
    title: "【2026年1月】新人AV女優おすすめランキング！厳選レビュー＆点数付き",
    subtitle: "2026年1月デビューの新人を全員チェックして厳選しました",
    date: "2026.02.14",
    intro: "2026年1月にデビューした新人AV女優の中から厳選してレビューします。新年一発目のデビュー組、粒ぞろいの月でした！",
    heroImg: "https://zetsubou.jp/wp-content/uploads/1sdnm00538vjp-3-500x281.webp",
    actresses: [
      {
        id: "b1",
        rank: 1,
        name: "白川ゆの",
        mainImg: "https://zetsubou.jp/wp-content/uploads/snos00081jp-8-500x281.webp",
        score: 9,
        review: "1月のNo.1。透明感のある美貌と天然ボケなキャラクターのギャップがたまらない。デビュー作の撮り方が非常にうまく、彼女の魅力を余すところなく引き出している。間違いなく2026年注目の一人。",
        href: "https://zetsubou.jp/av/newface/selection-2026/",
        workImages: [
          "https://zetsubou.jp/wp-content/uploads/snos00081jp-8-500x281.webp",
        ],
        debutDate: "2026年1月",
        maker: "各社",
      },
    ],
  },
];

export const actressDetailPages = [
  {
    id: "ad-1",
    slug: "suzumori-remu",
    name: "涼森れむ",
    profileImg: "https://zlovers.jp/wp-content/uploads/suzumori-remu-eye-1-640x360.jpg",
    heroImg: "https://zlovers.jp/wp-content/uploads/suzumori-remu-eye-1-640x360.jpg",
    rank: "SSS",
    debutDate: "2022年4月",
    maker: "S1 NO.1 STYLE",
    height: "158cm",
    bust: "F",
    waist: "57cm",
    hip: "85cm",
    bio: "2022年4月にS1 NO.1 STYLEからデビューした超絶美女。デビュー直後からその圧倒的な美貌と演技力で業界を席巻し、わずか1年でトップ女優の座に君臨。清楚な外見とは裏腹に激しいシーンも全力でこなす姿勢がファンを魅了し続けている。スタイル・顔・演技力の三拍子が揃った現役最強クラスの女優。",
    totalScore: 10,
    works: [
      {
        id: "w1",
        title: "【デビュー作】涼森れむ SOLOデビュー 清楚系美女の衝撃初体験",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20DVD%20cover%20elegant%20beautiful%20actress%20debut%20solo%20work%20professional%20photography%20studio%20lighting%20clean%20white%20background%20product%20shot&width=320&height=180&seq=ad1w1&orientation=landscape",
        href: "https://zlovers.jp/suzumori-remu/",
        score: 10,
        review: "デビュー作とは思えない完成度の高さ。緊張感の中にも堂々とした演技が光り、S1の丁寧な撮影と相まって最高の仕上がりになっている。顔面偏差値が高すぎて見ているだけで幸せになれる一作。",
        releaseDate: "2022年4月",
        maker: "S1 NO.1 STYLE",
        genre: "単体作品",
      },
      {
        id: "w2",
        title: "涼森れむ 専属第2弾 美しき肢体の全て",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20DVD%20cover%20beautiful%20actress%20second%20work%20professional%20photography%20studio%20lighting%20elegant%20pose%20clean%20background%20product%20shot&width=320&height=180&seq=ad1w2&orientation=landscape",
        href: "https://zlovers.jp/suzumori-remu/",
        score: 9,
        review: "2作目にして既に貫禄すら感じる。デビュー作より更に大胆になった演技と、磨きがかかった美貌のコンビネーションが最高。S1の映像クオリティも相変わらず高く、全シーン見応えがある。",
        releaseDate: "2022年7月",
        maker: "S1 NO.1 STYLE",
        genre: "単体作品",
      },
      {
        id: "w3",
        title: "涼森れむ VR作品 超高画質で体験する至高の時間",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20VR%20DVD%20cover%20beautiful%20actress%20virtual%20reality%20work%20professional%20photography%20studio%20lighting%20clean%20background%20product%20shot&width=320&height=180&seq=ad1w3&orientation=landscape",
        href: "https://zlovers.jp/suzumori-remu/",
        score: 10,
        review: "VR作品の中でも群を抜いたクオリティ。れむちゃんの美貌がVRで更に際立ち、没入感が半端ない。VR持ってる人は絶対に見るべき一作。これのためにVR買っても後悔しないレベル。",
        releaseDate: "2023年1月",
        maker: "S1 NO.1 STYLE",
        genre: "VR",
      },
      {
        id: "w4",
        title: "涼森れむ 1周年記念作品 感謝を込めて",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20DVD%20cover%20beautiful%20actress%20anniversary%20work%20professional%20photography%20studio%20lighting%20elegant%20clean%20background%20product%20shot&width=320&height=180&seq=ad1w4&orientation=landscape",
        href: "https://zlovers.jp/suzumori-remu/",
        score: 9,
        review: "デビュー1周年を記念した豪華作品。ファンへの感謝が伝わる内容で、これまでの集大成とも言える仕上がり。全シーンに気合いが入っており、ファンなら絶対に見逃せない。",
        releaseDate: "2023年4月",
        maker: "S1 NO.1 STYLE",
        genre: "単体作品",
      },
    ],
  },
  {
    id: "ad-2",
    slug: "ishikawa-mio",
    name: "石川澪",
    profileImg: "https://zlovers.jp/wp-content/uploads/ishikwa-mio-eye-640x360.jpg",
    heroImg: "https://zlovers.jp/wp-content/uploads/ishikwa-mio-eye-640x360.jpg",
    rank: "SS",
    debutDate: "2023年6月",
    maker: "IDEAPOCKET",
    height: "155cm",
    bust: "E",
    waist: "55cm",
    hip: "83cm",
    bio: "2023年6月にIDEAPOCKETからデビューした最上位天使。清楚で透明感のある外見が特徴で、デビュー直後から多くのファンを獲得。IDEAPOCKETの高品質な映像と彼女の美貌が完璧にマッチしており、毎作品が高評価を獲得している。",
    totalScore: 9,
    works: [
      {
        id: "w1",
        title: "石川澪 デビュー作 清楚系天使の衝撃初登場",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20DVD%20cover%20elegant%20beautiful%20actress%20debut%20work%20IDEAPOCKET%20professional%20photography%20studio%20lighting%20clean%20white%20background%20product%20shot&width=320&height=180&seq=ad2w1&orientation=landscape",
        href: "https://zlovers.jp/ishikawa-mio/",
        score: 9,
        review: "IDEAPOCKETらしい高品質な映像と石川澪の清楚な美貌が完璧にマッチ。デビュー作とは思えない落ち着いた演技と、それでいて全力な姿勢が印象的。今後の活躍が非常に楽しみな一作。",
        releaseDate: "2023年6月",
        maker: "IDEAPOCKET",
        genre: "単体作品",
      },
      {
        id: "w2",
        title: "石川澪 第2弾 天使の素顔",
        img: "https://readdy.ai/api/search-image?query=Japanese%20AV%20DVD%20cover%20beautiful%20actress%20second%20work%20IDEAPOCKET%20professional%20photography%20studio%20lighting%20elegant%20pose%20clean%20background%20product%20shot&width=320&height=180&seq=ad2w2&orientation=landscape",
        href: "https://zlovers.jp/ishikawa-mio/",
        score: 9,
        review: "2作目でさらに磨きがかかった。デビュー作より大胆になりつつも清楚感は健在。IDEAPOCKETの映像美と彼女の美貌の相乗効果が最高。",
        releaseDate: "2023年10月",
        maker: "IDEAPOCKET",
        genre: "単体作品",
      },
    ],
  },
];

export const rankingPageItems = [
  {
    id: "1",
    rank: 1,
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/55979-featured-320x180.webp",
    title: "【完全網羅】2025-2026年デビュー・デビュー予定の新人AV女優リスト",
    href: "https://av.zetsubou.org/newface/list-2025/",
    views: "808,444 views",
  },
  {
    id: "2",
    rank: 2,
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/50188-featured-320x180.webp",
    title: "【可愛さの暴力】可愛いAV女優ランキング2026!顔面最強・美人・神スタイル30選",
    href: "https://av.zetsubou.org/actress-ranking/",
    views: "751,581 views",
  },
  {
    id: "3",
    rank: 3,
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/43040-featured-320x180.webp",
    title: "【俺たちの憧れ】かわいいショートカットAV女優を30人紹介-2026年の1位はこの子だ!",
    href: "https://av.zetsubou.org/short-hair/",
    views: "375,002 views",
  },
  {
    id: "4",
    rank: 4,
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/50144-featured-320x180.webp",
    title: "【超完全まとめ】2024~2026年のおすすめ人気AV女優&全ジャンル作品完全リスト!",
    href: "https://av.zetsubou.org/av-2025/",
    views: "234,074 views",
  },
  {
    id: "5",
    rank: 5,
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/67111-featured-320x180.webp",
    title: "【おっぱい戦闘力】巨乳・爆乳AV女優ランキング40選!美人・新人・殿堂入りまで徹底解説",
    href: "https://av.zetsubou.org/kyonyu/",
    views: "223,800 views",
  },
  {
    id: "6",
    rank: 6,
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/19944-featured-320x180.webp",
    title: "【絶望しか感じない】伝説の鬼畜レイプAVを紹介させてくれ【極悪リスト】",
    href: "https://av.zetsubou.org/rape/",
    views: "219,125 views",
  },
  {
    id: "7",
    rank: 7,
    img: "https://av.zetsubou.org/wp-content/uploads/wordpress-popular-posts/55764-featured-320x180.webp",
    title: "これが最高のVRAVだ!2026年【アダルトVR殿堂入り】オススメVRエロ動画",
    href: "https://av.zetsubou.org/vrav/masterpiece/",
    views: "205,881 views",
  },
];
